const VoiceSendLogList = () => import('Views/voice/voice-send-log-list');

export default[
  { path: '/voice-send-log-list', component: VoiceSendLogList },
];



// WEBPACK FOOTER //
// ./src/router/voiceSendLog.js